<template>
  <h4 class="sub-heading">{{headingText}}</h4>
</template>

<script>
import Component, { mixins } from 'vue-class-component'

import { MetadataFallbackTextMixin } from './metadata-mixin'

@Component({
})
export default class SubHeading extends mixins(MetadataFallbackTextMixin) {
  /* Getters */
  get headingText () {
    return this.useFallbackText ? this.fallbackText : this.mainDisplayText
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h4 {
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/SubHeading.vue